import { Navigate, Route, Routes } from "react-router-dom";
import { AgentEvaluationProvider } from "./context/AgentEvaluationContext";
import Tabs from "./_components/Tabs";
import HistoryRecordDatatable from "views/agent/collection/info-agent/evaluate/HistoryRecordDatatable";
import DatasetView from "views/agent/collection/info-agent/evaluate/DatasetView";

const AgentEvaluate = () => {
  return (
    <AgentEvaluationProvider>
      <Tabs />
      <Routes>
        <Route path="/" element={<Navigate to="datasets" replace />} />
        <Route path="/datasets" element={<DatasetView />} />
        <Route path="/history" element={<HistoryRecordDatatable />} />
      </Routes>
    </AgentEvaluationProvider>
  );
};

export default AgentEvaluate;
